// Launch Guide theme. Small on purpose: the pages work without it.
(function () {
  // Product page: picking options finds the matching variant, then updates the price, the
  // button and the address, so a shared link opens on the size that was picked.
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var data = document.querySelector('[data-product-json]');
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var selects = form.querySelectorAll('[data-option-index]');
    var idInput = form.querySelector('[data-variant-id]');
    var addButton = form.querySelector('[data-add]');
    var price = document.querySelector('[data-price]');
    var money = function (cents) {
      var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: code }).format(cents / 100);
    };
    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        var picked = Array.prototype.map.call(selects, function (s) { return s.value; });
        var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === picked[i]; }); });
        if (!match) { addButton.disabled = true; addButton.textContent = 'Not available'; return; }
        idInput.value = match.id;
        addButton.disabled = !match.available;
        addButton.textContent = match.available ? 'Add to cart' : 'Sold out';
        if (price) price.textContent = money(match.price);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
        if (match.featured_media) {
          var image = document.querySelector('[data-media-id="' + match.featured_media.id + '"]');
          if (image) image.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    });
  });

  // Add to cart without leaving the page: the button says it worked and the header count updates.
  // If anything goes wrong the form submits the ordinary way and lands on the cart.
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var button = form.querySelector('[data-add]');
    var done = form.querySelector('[data-added]');
    form.addEventListener('submit', function (event) {
      if (event.submitter && event.submitter !== button) return;
      if (!window.fetch || form.dataset.plain) return;
      event.preventDefault();
      var label = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding…';
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form)
      }).then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch((Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
          button.disabled = false;
          button.textContent = label;
          if (done) done.hidden = false;
        })
        .catch(function () { form.dataset.plain = '1'; button.disabled = false; button.textContent = label; form.submit(); });
    });
  });

  // Collection page: the sort menu reloads with the chosen order.
  var sort = document.querySelector('[data-sort-by]');
  if (sort) sort.addEventListener('change', function () {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    window.location.assign(url);
  });

  // Product page: "More prints" is fetched after the page loads.
  var more = document.querySelector('[data-recommendations]');
  if (more && !more.querySelector('.product-grid')) {
    fetch(more.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) more.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  }
  // The free sticker form (the Shopify Forms app) draws itself inside its own sealed-off part of the
  // page, where the theme's stylesheet cannot reach. On a phone its picture was a fixed 320px tall,
  // which pushed the button off the screen. This gives the form a small stylesheet of its own: a
  // shorter picture and tighter spacing, so the whole form fits. The class names are the app's and
  // carry a changing suffix, so they are matched by their stable middle.
  var FORM_CSS = '@media (max-width: 640px) {' +
    '[class*="_formContainer_"] { grid-template-rows: min(24dvh, 190px) auto !important; max-height: calc(100dvh - 24px) !important; }' +
    '[class*="_formContainer_"] > div:first-child { background-size: contain !important; background-repeat: no-repeat !important; background-position: center !important; margin-top: 14px; }' +
    '[class*="_gridItemContent_"] { padding: 14px 22px 18px !important; }' +
    '[class*="_formFieldset_"] { margin-top: 12px !important; }' +
    'textarea { height: 72px !important; min-height: 0 !important; }' +
    '}';
  var styleForm = function () {
    var host = document.querySelector('shopify-forms-embed');
    if (!host || !host.shadowRoot) return false;
    if (!host.shadowRoot.querySelector('[data-theme-form-style]')) {
      var style = document.createElement('style');
      style.setAttribute('data-theme-form-style', '');
      style.textContent = FORM_CSS;
      host.shadowRoot.appendChild(style);
    }
    return true;
  };
  // The app loads after the page, so look for it for the first half minute.
  if (!styleForm()) {
    var tries = 0;
    var timer = setInterval(function () { if (styleForm() || ++tries > 60) clearInterval(timer); }, 500);
  }
})();
